import { ResponsiveHeatMap } from '@nivo/heatmap';
import ReactDOMServer from 'react-dom/server';
import { AppRemixIcon } from '@/layout/AppComponents';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';
import RiskCellComponent from './CellComponents/RiskCellComponent';

const Report48OnlineInfo = ({ responseData }) => {
  return (
    <div className="row mt-3">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <h3 className="wl-title wl-title-color">
              <Translator file="module-legalCompliance" name="module.lc.risk" />
            </h3>
            <p>
              <Translator
                file="module-intelligence"
                name="module.int.ob-quantity"
                variables={{
                  obligationCount: responseData?.onlineInfo?.totalRiskCount,
                }}
                isHtml
              />
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr' }}>
              <div>
                <p>
                  <b>
                    <Translator file="module-intelligence" name="risk" />:
                  </b>
                  <br />
                  <AppRemixIcon
                    icon="circle"
                    filled
                    color={colors?.probSevRisk[3]}
                  />{' '}
                  <Translator file="filter" name="filter.probability.3.m" />
                  <br />
                  <AppRemixIcon
                    icon="circle"
                    filled
                    color={colors?.probSevRisk[2]}
                  />{' '}
                  <Translator file="filter" name="filter.probability.2.m" />
                  <br />
                  <AppRemixIcon
                    icon="circle"
                    filled
                    color={colors?.probSevRisk[1]}
                  />{' '}
                  <Translator file="filter" name="filter.probability.1.m" />
                  <br />
                  <AppRemixIcon
                    icon="circle"
                    filled
                    color={colors?.probSevRisk[0]}
                  />{' '}
                  <Translator file="filter" name="filter.probability.0.m" />
                  <br />
                </p>
              </div>
              <div>
                <div
                  style={{
                    minHeight: '400px',
                    height: '50px',
                    width: '100%',
                    position: 'relative',
                  }}
                >
                  <ResponsiveHeatMap
                    data={responseData.onlineInfo?.risk}
                    margin={{
                      top: 100,
                      right: 60,
                      bottom: 60,
                      left: 120,
                    }}
                    forceSquare
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      orient: 'center',
                      tickSize: 12,
                      tickPadding: 7,
                      tickRotation: 0,
                      legend: ReactDOMServer.renderToString(
                        <Translator file="filter" name="filter.severity" />
                      ),
                      legendPosition: 'middle',
                      legendOffset: 50,
                    }}
                    axisLeft={{
                      orient: 'center',
                      tickSize: 12,
                      tickPadding: 7,
                      tickRotation: 0,
                      legend: ReactDOMServer.renderToString(
                        <Translator file="filter" name="filter.probability" />
                      ),
                      legendPosition: 'middle',
                      legendOffset: -80,
                    }}
                    cellComponent={(cell) =>
                      RiskCellComponent(
                        cell,
                        responseData?.onlineInfo?.riskMatrix
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report48OnlineInfo;
